/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

export type Int64 = string | number;

export interface Operation {
  /** 指标名称，参考 */
  operation_type: string;
  /** 指标的值 */
  operation_value: string;
  /** 指标的周期 */
  operation_period?: string;
  /** 指标空间id */
  space_id?: string;
  /** 指标空间id */
  psm?: string;
  /** 指标环境online or boe */
  fornax_env?: string;
  /** 模型id */
  model_id?: string;
  /** graph id */
  graph_uid?: string;
}
/* eslint-enable */
